import { forwardRef, useEffect, useMemo, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./E5ReviewAndValidation.scss"

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const E5ReviewAndValidation = forwardRef(({ E5ReviewAndValidationData,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (E5ReviewAndValidationData) {
            reset(prev => ({ ...prev, e5: E5ReviewAndValidationData }));
        }
    }, [E5ReviewAndValidationData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("e5");
        const payload = {
            ...filteredFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const E5ReviewAndValidation = await callApi({
                method: "POST",
                url: API_ROUTES.E5(vesselMstId),
                data: payload,
            });
            if (E5ReviewAndValidation?.isSuccess) {
                emitToasterMsg("success", "Table E.5", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, e5: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table E.5", E5ReviewAndValidation?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table E.5", error?.errorMessage);
        }
    };

    const filteredFields = useMemo(() => {
        return cSectionFormFields
            .filter(f => f.name !== "formulaeAndDataSources")
            .map(f =>
                f.name === "referenceToProcedure"
                    ? { ...f, label: "Reference for procedure" }
                    : f
            );
    }, []);

    return (
        <div className="e5-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Internal reviews and validation of data relevant to Regulation (EU) 2015/757</h6>
                </MDBCol>
            </MDBRow>

            {filteredFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`e5.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`e5_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="e5_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save</Button>
            </div>
        </div>
    );
});

export default E5ReviewAndValidation;